import {
  DSA_REVIEW_CHECK,
  DSA_REVIEW_DISMISS,
  DSA_REVIEWED_SET,
  DSA_MISSING_INFO_SHOW,
  DSA_MISSING_INFO_DISMISS,
} from "./DSAReviewTypes";

const initialState = {
  showDsaReviewPopup: false,
  showDsaMissingInfoPopup: false,
  dsaReviewed: null,
};

const dsaReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case DSA_REVIEWED_SET:
      return { ...state, dsaReviewed: action.payload };
    case DSA_REVIEW_CHECK:
      return { ...state, showDsaReviewPopup: action.payload };
    case DSA_REVIEW_DISMISS:
      return { ...state, showDsaReviewPopup: false };
    case DSA_MISSING_INFO_SHOW:
      return { ...state, showDsaMissingInfoPopup: action.payload };
    case DSA_MISSING_INFO_DISMISS:
      return { ...state, showDsaMissingInfoPopup: false };
    default:
      return state;
  }
};

export default dsaReviewReducer;